import React from "react";
import "./App.css";
import RoutesWrapper from "./routes/route-wrapper";
import Toast from "./components/toast";
import ErrorBoundary from "./components/error-boundary";

function App() {
  return (
    <ErrorBoundary>
      <RoutesWrapper />
      <Toast />
    </ErrorBoundary>
  );
}

export default App;
